// function moveLaClassesToLink() {
//   document.querySelectorAll('.wp-block-button').forEach(wrapper => {
//     const link = wrapper.querySelector('.wp-block-button__link');
//     if (!link) return;

//     // apanha classes do tipo "la-*"
//     const laClasses = [...wrapper.classList].filter(c => c.startsWith('la-'));
//     if (!laClasses.length) return;

//     // adiciona ao link e remove do wrapper
//     laClasses.forEach(c => link.classList.add(c));
//     laClasses.forEach(c => wrapper.classList.remove(c));
//   });
// }

// document.addEventListener('DOMContentLoaded', moveLaClassesToLink);
// document.addEventListener('wp-blocks-rendered', moveLaClassesToLink);

function moveLaClasses() {

  // 1️⃣ Botões Gutenberg
  document.querySelectorAll('.wp-block-button').forEach(wrapper => {
    const link = wrapper.querySelector('.wp-block-button__link');
    if (!link) return;

    const laClasses = [...wrapper.classList].filter(c => c.startsWith('la-'));
    if (!laClasses.length) return;

    laClasses.forEach(c => {
      link.classList.add(c);
      wrapper.classList.remove(c);
    });
  });

  // 2️⃣ Menu principal
  document.querySelectorAll('#primary-menu li').forEach(item => {
    const link = item.querySelector('a');
    if (!link) return;

    const laClasses = [...item.classList].filter(c => c.startsWith('la-'));
    if (!laClasses.length) return;

    laClasses.forEach(c => {
      link.classList.add(c);
      item.classList.remove(c);
    });
  });
}

document.addEventListener('DOMContentLoaded', moveLaClasses);
document.addEventListener('wp-blocks-rendered', moveLaClasses);